export function getResolvedPublishedDocumentPath(
  documentId: number,
  latestPublishedReleaseId: number | null,
  shouldOpenInWord: boolean,
): string {
  const searchParams = new URLSearchParams();

  if (latestPublishedReleaseId !== null) {
    searchParams.set("releaseId", latestPublishedReleaseId.toString());
  }

  if (shouldOpenInWord) {
    searchParams.set("open", "word");
  }

  const query = searchParams.toString();
  return `/documents/${documentId}${query ? `?${query}` : ""}`;
}

export function consumeWordLaunchIntent(
  searchParams: URLSearchParams,
): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete("open");

  return nextSearchParams;
}
